import { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

/**
 * Redirects to /reset-password when the URL hash contains type=recovery.
 *
 * Supabase password recovery emails (especially those sent from the Supabase dashboard)
 * may redirect to the site root (/) instead of /reset-password. This hook detects the
 * recovery hash fragment and navigates to the correct page.
 */
export function useRecoveryRedirect() {
    const navigate = useNavigate();
    const location = useLocation();

    useEffect(() => {
        if (window.location.hash.includes('type=recovery') && location.pathname !== '/reset-password') {
            navigate('/reset-password', { replace: true });
        }
    }, []); // eslint-disable-line react-hooks/exhaustive-deps
}
